export default __webpack_public_path__ + "static/media/Statistics_2010.9dce9488.zip";